import { render, staticRenderFns } from "./micro-page-data.vue?vue&type=template&id=3c655441&scoped=true&"
import script from "./micro-page-data.vue?vue&type=script&lang=js&"
export * from "./micro-page-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c655441",
  null
  
)

export default component.exports